import { SessionInfoResult } from '../types/SessionInfo';
import { NoInputVizPortalClientMethod } from '../VizPortalClientMethod';

export const GetSessionInfoMethod = new NoInputVizPortalClientMethod<SessionInfoResult>('getSessionInfo');
